/**
 * @overview minimally-styled "text-only" button
 */

import React from 'react'
import { Button } from 'evergreen-v4'

class TextButton extends React.PureComponent {
  render() {
    return (
      <Button
        appearance="minimal"
        borderRadius="0"
        height="auto"
        lineHeight="unset"
        padding="0"
        {...this.props}
      />
    )
  }
}

export default TextButton
